import React from 'react';
import { Navigate } from 'react-big-calendar';
import moment from 'moment';

// Import TimeGrid directly from react-big-calendar internal components
const TimeGrid = require('react-big-calendar/lib/TimeGrid').default;

class ThreeDayView extends React.Component {
  render() {
    const { date, localizer, max, step, timeslots, formats, ...props } = this.props;
    
    // Calculate the range for exactly 3 days starting from the current date
    const start = moment(date).startOf('day');
    const range = [];
    
    for (let i = 0; i < 3; i++) {
      range.push(moment(start).add(i, 'day').toDate());
    }
    
    // Set min time to start of day (00:00)
    const min = new Date();
    min.setHours(0, 0, 0, 0);
    
    return (
      <TimeGrid
        {...props}
        range={range}
        eventOffset={15}
        localizer={localizer}
        date={date}
        min={min}
        max={max}
        step={step || 30}
        timeslots={timeslots || 2}
        formats={formats}
      />
    );
  }
  
  // Navigation helper - move by 1 day
  static navigate(date, action) {
    switch (action) {
      case Navigate.PREVIOUS:
        return moment(date).subtract(1, 'days').toDate();
      case Navigate.NEXT:
        return moment(date).add(1, 'days').toDate();
      default:
        return date;
    }
  }
  
  // Title for the view
  static title(date, { localizer }) {
    const start = moment(date);
    const end = moment(date).add(2, 'days');
    
    // If same month, show "Sep 9-11, 2025"
    if (start.month() === end.month()) {
      return `${start.format('MMM D')}-${end.format('D, YYYY')}`;
    }
    // If different months, show "Jan 30 - Feb 1, 2025"
    return `${start.format('MMM D')} - ${end.format('MMM D, YYYY')}`;
  }
}

export default ThreeDayView;
